import { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import EmptyState from '@/components/admin/EmptyState';
import { adminApi } from '@/lib/api';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

const EVENT_LABEL = { page_view: 'Vistas', whatsapp_click: 'WhatsApp', cta_click: 'CTA', form_submit: 'Formularios', social_click: 'Social', gallery_click: 'Galería', map_click: 'Mapa' };

export default function AdminAnalyticsPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => { adminApi.analyticsSummary(30).then(setData).finally(() => setLoading(false)); }, []);
    if (loading) return <AdminLayout title="Analíticas"><div className="h-64 bg-white rounded-2xl border border-border animate-pulse" /></AdminLayout>;
    const byType = (data?.by_type || []).map((x) => ({ name: EVENT_LABEL[x.type] || x.type, count: x.count }));
    const topPages = data?.top_pages || [];
    return (
        <AdminLayout title="Analíticas (últimos 30 días)">
            <p className="text-sm text-muted-foreground mb-4">Métricas internas (almacenadas en MongoDB). No usamos GA o píxeles externos.</p>
            <div className="grid gap-4 lg:grid-cols-2">
                <div className="rounded-2xl bg-white border border-border p-4 shadow-[var(--shadow-soft)]">
                    <h3 className="font-display font-semibold mb-2">Eventos por tipo</h3>
                    {byType.length === 0 ? <EmptyState title="Sin eventos" /> : (
                        <div className="h-72"><ResponsiveContainer width="100%" height="100%"><BarChart data={byType} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="hsl(220 13% 91%)" />
                            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                            <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                            <Tooltip />
                            <Bar dataKey="count" fill="hsl(190 95% 45%)" radius={[8, 8, 0, 0]} />
                        </BarChart></ResponsiveContainer></div>
                    )}
                </div>
                <div className="rounded-2xl bg-white border border-border p-4 shadow-[var(--shadow-soft)]">
                    <h3 className="font-display font-semibold mb-2">Páginas más vistas</h3>
                    {topPages.length === 0 ? <EmptyState title="Sin vistas aún" /> : (
                        <ul className="divide-y divide-border">
                            {topPages.map((p) => (
                                <li key={p.page} className="py-2 flex items-center justify-between text-sm"><span className="truncate max-w-xs">{p.page}</span><span className="tabular-nums font-medium">{p.count}</span></li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </AdminLayout>
    );
}
